import { useState } from "react";
import { MessageSquarePlus, X, Loader2, Camera } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { useI18n } from "../lib/i18n";

/** Floating in-app feedback button (every screen). Text + optional screenshot (via getDisplayMedia capture or file). */
export function FeedbackButton({ lang: langProp }) {
  const { lang: ctxLang } = useI18n();
  const lang = langProp || ctxLang;
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [shot, setShot] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState("");
  const nl = lang === "nl";
  const onFile = (e) => { const f = e.target.files?.[0]; if (!f) return; const r = new FileReader(); r.onload = () => setShot(String(r.result)); r.readAsDataURL(f); };
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setDone("");
    try {
      await api.post("/feedback", { message: msg, page: window.location.pathname, screenshot_base64: shot, lang });
      setDone(nl ? "Bedankt! Je feedback is verstuurd." : "Thanks! Your feedback has been sent."); setMsg(""); setShot(null);
      setTimeout(() => { setOpen(false); setDone(""); }, 1500);
    } catch (err) { setDone(formatApiErrorDetail(err?.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} aria-label="Feedback" title="Feedback"
        className="fixed right-4 z-40 h-11 w-11 lg:w-auto lg:px-4 rounded-full bg-[#0f1c17] text-white text-xs font-semibold shadow-lg flex items-center justify-center gap-2 hover:bg-emerald-800 transition-colors lg:bottom-5"
        style={{ bottom: "var(--pm-fab-bottom, calc(var(--pm-nav-h) + var(--sab) + 12px))" }} data-testid="feedback-open">
        <MessageSquarePlus size={16} /> <span className="hidden lg:inline">Feedback</span>
      </button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center p-0 sm:p-4" data-testid="feedback-modal">
          <form onSubmit={submit} className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl p-5 space-y-3">
            <div className="flex items-center justify-between"><div className="font-semibold">{nl ? "Feedback geven" : "Send feedback"}</div><button type="button" onClick={() => setOpen(false)} data-testid="feedback-close"><X size={16} /></button></div>
            <textarea required value={msg} onChange={(e) => setMsg(e.target.value)} rows={4} placeholder={nl ? "Wat werkt niet of wat mis je? (pagina en tijd worden automatisch meegestuurd)" : "What's broken or missing? (page and time are attached automatically)"} className="w-full rounded-xl border border-slate-300 p-3 text-sm" data-testid="feedback-text" />
            <label className="flex items-center gap-2 text-xs text-slate-600 cursor-pointer"><Camera size={14} /> {shot ? (nl ? "Screenshot toegevoegd ✓" : "Screenshot attached ✓") : (nl ? "Screenshot toevoegen (optioneel)" : "Attach screenshot (optional)")}<input type="file" accept="image/*" onChange={onFile} className="hidden" data-testid="feedback-screenshot" /></label>
            {done && <div className="text-xs text-emerald-700" data-testid="feedback-status">{done}</div>}
            <button type="submit" disabled={busy || !msg.trim()} className="w-full h-11 rounded-xl bg-[#0f1c17] text-white text-sm font-semibold disabled:opacity-50 flex items-center justify-center gap-2" data-testid="feedback-submit">{busy && <Loader2 size={14} className="animate-spin" />} {nl ? "Versturen" : "Send"}</button>
          </form>
        </div>
      )}
    </>
  );
}
